import React from 'react'
import { Info as InfoIcon } from 'react-feather'
import { Box, Typography } from '@material-ui/core'

import { WhiteTooltip } from 'components'

import useStyles from './styles'

const CalcExplanation = () => {
  const classes = useStyles()

  return (
    <Box className={classes.container}>
      <Typography variant="body2" className={classes.text}>
        Como é feito o cálculo do larga escala
      </Typography>
      <WhiteTooltip
        arrow
        placement="top"
        title={
          <>
            <Typography variant="body2">
              Para identificar se o incidente caracteriza tratamento de dados em
              larga escala, preencha a faixa de classificação e o valor de
              tratamento na tabela. O sistema calcula automaticamente o valor
              atribuído com base nessas informações.
            </Typography>
            <Typography variant="body2">
              O resultado é interpretado nas seguintes faixas:
            </Typography>
            <Box component="ul" className={classes.list}>
              <Typography component="li" variant="body2">
                <strong>Até 20:</strong> o tratamento não é considerado larga
                escala.
              </Typography>
              <Typography component="li" variant="body2">
                <strong>Entre 20 e 24:</strong> o resultado está em avaliação —
                é necessário validar manualmente se o tratamento caracteriza
                larga escala.
              </Typography>
              <Typography component="li" variant="body2">
                <strong>25 ou mais:</strong> o tratamento é considerado larga
                escala e pode requerer comunicação à ANPD.
              </Typography>
            </Box>
            <Typography variant="body2">
              O DPO avalia todas as informações enviadas e os critérios
              específicos do caso para emitir o parecer final.
            </Typography>
          </>
        }
      >
        <Box component="span" className={classes.infoIcon}>
          <InfoIcon size={16} />
        </Box>
      </WhiteTooltip>
    </Box>
  )
}

export default CalcExplanation
